<template>
  <div data-color="dark" class="js-header-panel">
     <div class="c-page c-blog u-pad-x-w3of12 u-pad-x-w1of12@sm u-pad-t-ultra">
        <header class="c-blog__header">
         <h1 class="t-h2 t-text--roman  t-text-lh--md u-marg-t-xxl u-color--gray u-marg-b-xl">
            <app-sliced-text :content="'News'"></app-sliced-text>
          </h1>
      </header>



        <div  v-if="areTherePosts"  v-for="(post,index)  in posts"   :key="post.id"    class="c-blog__article t-link u-flex u-flex-fd--column@sm u-pad-y-xl">
           <div class="u-w2of10 u-fit-w@sm">
              <div>
                <span class="c-blog__article__date t-text--roman u-color--gray-light--news">{{post.dateFormated.day}}</span>
                <span class="t-text--xxs t-text-ls--md u-uppercase u-block u-color--gray-light--news">{{post.dateFormated.month+" "+post.dateFormated.year}}</span>
              </div>
           </div>
           <div class="u-marg-t-md@sm u-w8of10 u-fit-w@sm u-pad-r-lg u-pad-r-0@sm">
              <h2 class="t-h5 t-text--roman u-marg-b-md u-color--gray" v-html="post.title"></h2>
              <p class="t-text--md u-color--gray" v-html="post.first_paragraph_shorted"></p>
           </div>
        </div>
       <div class="c-blog__article u-flex u-flex-fd--column@sm u-pad-y-xl" v-if="!areTherePosts">
        <div class="u-fit-w">
            <h2 class="t-h5 t-text--roman u-marg-b-md" v-html="posts[0].title"></h2>
        </div>
      </div>
        <!---->
        <footer class="c-blog__footer u-pad-t-md u-pad-b-xxl">
           <div class="c-blog__footer__prev u-w2of10 u-uppercase">
                 <router-link v-if="currentPageIndex > 1 && 0 !== currentPageIndex" class="c-blog__footer__prev__link u-relative u-color--gray" :to="'/resourcegroup/en/resourcegroup-media-news-articles?page='+(currentPageIndex - 1)">
                    Prev
                 </router-link>
            </div>
           <div class="c-blog__footer__pagination u-w6of10">
                     <router-link v-if="currentPageIndex>3" :to="'/resourcegroup/en/resourcegroup-media-news-articles?page=1'+pages[0].index" class="c-blog__footer__pagination__page u-relative u-color--gray" :class="'c-blog__footer__pagination__page--'+pages[0].index">
                    {{"0"+(pages[0].index)}}
                    </router-link>
                    <div v-if="currentPageIndex>4"  class="c-blog__footer__pagination__page" >
                      ...
                   </div>
                   <router-link v-if="indexp <= currentPageIndex + 1 && indexp >= currentPageIndex || indexp >= currentPageIndex - 3 && indexp <= currentPageIndex"  v-for="(page, indexp)  in pages" :key="page.id" class="c-blog__footer__pagination__page u-relative u-color--gray" :class="[{'is-active':page.index===currentPageIndex},'c-blog__footer__pagination__page--'+indexp]" :to="'/resourcegroup/en/resourcegroup-media-news-articles?page='+ page.index">
                     {{page.index<10?"0"+page.index:page.index}}
                   </router-link>
                   <div  v-if="currentPageIndex<pages.length-3"   class="c-blog__footer__pagination__page">
                     ...
                   </div>

                   <router-link v-if="currentPageIndex < pages.length-2"  class="c-blog__footer__next__link u-relative u-color--gray" :class="['c-blog__footer__pagination__page--'+pages[pages.length-1].index]" :to="'/resourcegroup/en/resourcegroup-media-news-articles?page='+ pages[pages.length-1].index">
                    {{pages[pages.length-1].index<10?"0"+pages[pages.length-1].index:pages[pages.length-1].index}}
                   </router-link>
         </div>
           <div class="c-blog__footer__next u-w2of10 u-uppercase">
           <router-link v-if="currentPageIndex < pages.length && 0 !== currentPageIndex"  class="c-blog__footer__next__link u-relative u-color--gray"  :to="'/resourcegroup/en/resourcegroup-media-news-articles?page='+ (currentPageIndex + 1)">
            Next
           </router-link>
         </div>
         </footer>
     </div>
     <app-footer :globalContent="globalContent" :adminContent="adminContent"></app-footer>
  </div>
</template>
<script>
import {format, compareAsc} from 'date-fns'
import AppFooter from  '../app-footer/index.vue'
import  AppSlicedText from '../app-sliced-text/index.vue'
export default
{
          components:{
                                    "app-sliced-text":AppSlicedText,
                                    "app-footer":AppFooter
                    },
                  props: {
                      adminContent: {
                          type: Object,
                          default: function() {}
                      },
                      globalContent: {
                          type: Object,
                          default: function() {}
                      },
                      headerPageSize: {
                          type: Array,
                          default: function() {}
                      }
                  },
                  data: function() {
                      return {
                          areTherePosts: !1
                      }
                  },
                  computed:
                  {
                      computedPosts: function()
                      {
                          var t = [];
                          if (this.$route.query.page)
                          {
                              if (Object.keys(this.adminContent.en.posts_page).length > 0)
                              {
                                  if (this.adminContent.en.posts_page[this.$route.query.page])
                                  {
                                      this.areTherePosts = !0;
                                      for (var e = 0, n = this.adminContent.en.posts_page[this.$route.query.page].length; e < n; e += 1)
                                      {
                                          var r = this.adminContent.en.posts_page[this.$route.query.page][e];
                                          r.dateFormated = {
                                              day: format(r.post_wp.post_date, "DD"),
                                              month: format(r.post_wp.post_date, "MMMM"),
                                              year: format(r.post_wp.post_date, "YY")
                                          };
                                          if(r.readmoreurl != ''&& r.readmoreurl)
                                            r.first_paragraph_shorted = r.first_paragraph_shorted + " <a href=\""+r.protocol+":\/\/"+r.readmoreurl+"\" target=\"_blanc\" class=\"c__item__link__News\">Read more<\/a>"
                                          t.push(r)
                                      }
                                  }
                                  else
                                  {
                                   this.areTherePosts = !1,
                                   t.push({
                                      title: "Error - Page not found",
                                      first_paragraph_shorted: "Incorrect page number. <br /> Please click on one of the page numbers below.",
                                      dateFormated: {
                                          day: 404,
                                          month: "",
                                          year: ""
                                      }
                                  })
                                }
                              }
                          }
                          else
                          {
                          this.areTherePosts = !1, t.push({
                              title: "No recents announcements yet.",
                              first_paragraph_shorted: "",
                              dateFormated: {
                                  day: "",
                                  month: "",
                                  year: ""
                              }
                          })
                        }
                          return t
                      },
                      computedPages: function()
                      {
                          var t = [];
                          if (this.$route.query.page) {
                              t.length = 0;
                              for (var e = 0, n = Object.keys(this.adminContent.en.posts_page).length; e < n; e += 1) {
                                  var r = Object.keys(this.adminContent.en.posts_page)[e];
                                  t.push({
                                      index: parseInt(r, 10),
                                      isVisible: !0
                                  })
                              }
                          }
                          return t
                      },
                      computedCurrentPageIndex: function()
                      {
                          var t = 1;
                          return this.$route.query.page && (t = this.adminContent.en.posts_page[this.$route.query.page] ? parseInt(this.$route.query.page, 10) : 0), t
                      }
                  },
                  beforeCreate: function()
                  {
                      this.$route.query.page || this.$router.push("/resourcegroup/en/resourcegroup-media-news-articles?page=1")
                  },
                  created: function()
                  {
                      this.adminContent.en.pages.blog.blog_is_active ? this.$route.query.page || this.$router.replace("/resourcegroup/en/resourcegroup-media-news-articles?page=1") : this.$router.replace("/404"),
                      this.onResize = this.onResize.bind(this),
                      this.posts = this.computedPosts,
                       this.pages = this.computedPages,
                        this.currentPageIndex = this.computedCurrentPageIndex,
                         this.eventHub.$on("resize", this.onResize)
                  },
                  destroyed: function()
                  {
                      this.eventHub.$off("resize", this.onResize)
                  },
                  mounted: function()
                  {
                      this.eventHub.$emit("page:ready"),
                      this.onResize()
                  },

                  methods:
                  {
                      onResize: function() {}
                  }
    }

</script>
<style  scoped>
</style>



// WEBPACK FOOTER //
// src/components/app-page-news/index.vue